import { Dispatch, memo, SetStateAction } from 'react';

import { TimelineFilters } from '@/forms/TimelineFilterForm/types';
import SharedActiveFilters from '@/ui/components/ActiveFilters';
import buildActiveFilterGroups from '@/utils/buildActiveFilterGroups';
import removeFilter from '@/utils/removeFilter';
import snakeToTitleCase from '@/utils/snakeToTitleCase';

interface Props {
  filters: Partial<TimelineFilters>;
  setFilters: Dispatch<SetStateAction<Partial<TimelineFilters>>>;
  values: Partial<TimelineFilters>;
}

const ActiveFilters = ({ filters, setFilters, values }: Props) => {
  const formatFilterValue = (value: string, filterName: string): string => {
    switch (filterName) {
      case 'created_at__gte':
      case 'created_at__lte':
        return new Date(value).toLocaleString([], { dateStyle: 'medium' });
      default:
        return snakeToTitleCase(value);
    }
  };

  return (
    <SharedActiveFilters
      groups={buildActiveFilterGroups({
        filters,
        formatValue: formatFilterValue,
        labels: { action: 'Event', created_at__gte: 'From', created_at__lte: 'To' }
      })}
      onClearAll={() => setFilters({ action: [] })}
      onRemove={(filterName, filterValue) =>
        removeFilter({ activeFilters: filters, filterName, filterValue, setFilters, values })
      }
    />
  );
};

export default memo(ActiveFilters);
